export const SET_PLAYING_TRACK = 'SET_PLAYING_TRACK';
export const SET_QUEUE = 'SET_QUEUE';
export const ADD_TO_QUEUE = 'ADD_TO_QUEUE';
export const SAVE_PLAYER_HISTORY = 'SAVE_PLAYER_HISTORY';
export const DEQUEUE = 'DEQUEUE';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const ADD_FAVORITE_TRACK = 'ADD_FAVORITE_TRACK';
export const REMOVE_FAVORITE_TRACK = 'REMOVE_FAVORITE_TRACK';
export const ADD_PLAYLIST = 'ADD_PLAYLIST';
export const REMOVE_PLAYLIST = 'REMOVE_PLAYLIST';
export const UPDATE_PLAYLIST = 'UPDATE_PLAYLIST';
export const RENAME_PLAYLIST = 'RENAME_PLAYLIST';
export const SET_PLAYER_REPEAT = 'SET_PLAYER_REPEAT';
export const SET_PLAYER_VOLUME = 'SET_PLAYER_VOLUME';
export const SET_PLAYER_MUTE = 'SET_PLAYER_MUTE';
export const CLEAN_ALL = 'CLEAN_ALL';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const MOVE_PREV_TRACK = 'MOVE_PREV_TRACK';
export const MOVE_NEXT_TRACK = 'MOVE_NEXT_TRACK';
